import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export const AsyncExportReportModal = Loadable({
  loader: () => /* webpackChunkName: "reporting-action-components-modals" */import('./ExportReportModal'),
  LoadingComponent: () => null
});